import { Chip, Grid } from "@material-ui/core";
import { HomeWork, InfoOutlined } from "@material-ui/icons";
import InfoIcon from "@material-ui/icons/Info";
import * as React from "react";
import {
  AutocompleteInput,
  CheckboxGroupInput,
  NumberInput,
  RadioButtonGroupInput,
  ReferenceInput,
  SelectInput,
  TextInput,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { ExperienceNoteType } from "../../../../Enums/ExperienceNoteType";
import { RequestType } from "../../../../Enums/RequestType";
import { OffWingChoices, PnSelectionChoices, ReleaseTypeChoices, RequestTypeChoices } from "../../Constant/Source";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import { useAuth } from "@airborne/react-admin";
import { connect } from "react-redux";
import { PbhRequestFileType } from "../../../../Enums/PbhRequestFileType";
import AarStorageSelectForm from "./Components/AarStorageSelectForm";
import { EightWingsStatus } from "../../../../Enums/EightWingsTabEnum";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const EightWingsInfo = props => {
  const { user } = useAuth();
  const notify = useNotify();

  React.useEffect(() => {
    if (!user?.isCustomer) {
      if (props?.status != EightWingsStatus.TTVerified || props?.status != EightWingsStatus.Reject) {
        let isExistFile = props?.requestDetail?.pbhRequestOrderFiles?.some(
          x =>
            x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Info &&
            x.pbhRequestFileTypeEnum === PbhRequestFileType.Defect
        );
        if (isExistFile) {
          notify("Bu kayıtta DEFECT dokümanını kontrol etmelisiniz.", "warning", false, false, 5000);
        }
      }
      if (props?.isNotInDafzaOrCoreReturn) {
        notify("Uyarı mesajı: Bu PN için DAFZA stok 0. Açık core bulunmaktadır.", "warning", false, false, 5000);
      }
    }
  }, []);
  const handleSubmit = async model => {};

  return (
    <>
      <Form
        initialValues={{ ...props?.selectedData, ...{ releaseType: props?.selectedData?.releaseType?.split(",") } }}
        onSubmit={handleSubmit}
        render={({ handleSubmit, form, values }) => (
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <>
                  <Separator />
                  <Grid {...gridContainerProps}>
                    <SectionTitle label="Contract Info" />
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        data-testid="text-input-contract.contractName"
                        source="contract.contractName"
                        label="Contract"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <RadioButtonGroupInput
                        data-testid="radio-input-requestType"
                        source="requestType"
                        label="Request Type"
                        fullWidth
                        defaultValue={Number(RequestType.PBH)}
                        choices={RequestTypeChoices}
                        variant="outlined"
                        disabled
                      />
                    </Grid>
                  </Grid>
                  <Separator />

                  <Grid {...gridContainerProps}>
                    <SectionTitle label="Order Info" />
                  </Grid>
                  <Grid {...gridContainerProps} alignItems={"flex-start"}>
                    <Grid item xs={12} sm={5}>
                      <RadioButtonGroupInput
                        source="isPreDefined"
                        label="PN Selection"
                        fullWidth
                        choices={PnSelectionChoices}
                        variant="outlined"
                        disabled
                      />
                      <TextInput
                        data-testid="text-input-pn"
                        source="pn"
                        label="Requested Part Number"
                        fullWidth
                        disabled
                        variant="outlined"
                      />
                      <TextInput
                        source="pnDescription"
                        label="Component Description"
                        fullWidth
                        disabled
                        variant="outlined"
                      />
                      <TextInput source="usedSn" label="Used SN" fullWidth disabled variant="outlined" />
                      <TextInput source="unserviceablePn" label="Core Unit PN" fullWidth disabled variant="outlined" />
                      <TextInput source="unserviceableSn" label="Core Unit SN" fullWidth disabled variant="outlined" />
                      <TextInput
                        source="pnDifferenceRemark"
                        label="Pn Difference Remark"
                        fullWidth
                        disabled
                        variant="outlined"
                      />
                      <TextInput source="melCategory" label="Mel Category" fullWidth disabled variant="outlined" />
                      <CustomDatetime
                        fullWidth
                        disabled
                        source="melDueDate"
                        label="Mel Due Date"
                        inputVariant={"dialog"}
                        variant="outlined"
                        showTime
                      />
                      <TextInput
                        data-testid="text-input-defectReason"
                        source="defectReason"
                        label="Defect Reason"
                        multiline
                        resettable
                        fullWidth
                        rows={3}
                        variant="outlined"
                        disabled
                      />

                      <Chip
                        key={props?.selectedData?.id + "_access"}
                        size="medium"
                        style={{ color: "#767676" }}
                        variant="outlined"
                        label={`Access: ${props?.selectedData?.access ?? "N/A"}`}
                        icon={<InfoIcon />}
                      />
                      <Chip
                        key={props?.selectedData?.id + "_repair"}
                        style={{ margin: "14px", color: "#767676" }}
                        size="medium"
                        variant="outlined"
                        label={`Repair: ${props?.selectedData?.repair ?? "N/A"}`}
                        icon={<InfoIcon />}
                      />
                      {user?.isCustomer !== true && (
                        <Chip
                          key={props?.selectedData?.id + "_in_stock"}
                          size="medium"
                          style={{ color: "#767676" }}
                          variant="outlined"
                          label={`In Stock: ${props?.selectedData?.inStock === true ? "Yes" : "No"}`}
                          icon={<HomeWork />}
                        />
                      )}
                      <RadioButtonGroupInput
                        source="offWing"
                        label="Off Wing"
                        fullWidth
                        choices={OffWingChoices}
                        variant="outlined"
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <NumberInput source="ataChapter" label="Ata Chapter" fullWidth variant="outlined" disabled />
                      <TextInput
                        data-testid="text-input-aircraft.acReg"
                        source="aircraft.acReg"
                        label="Aircraft"
                        fullWidth
                        disabled
                        variant="outlined"
                      />

                      <CheckboxGroupInput
                        source="releaseType"
                        choices={ReleaseTypeChoices()}
                        disabled
                        variant="outlined"
                      />
                      <ReferenceInput
                        label="Airport Code"
                        source="airportCode"
                        reference="cdmlocations"
                        translateChoice={false}
                        filterToQuery={searchText => ({ id__contains: searchText })}
                        sort={{ field: "id", order: "ASC" }}
                      >
                        <AutocompleteInput
                          optionText="id"
                          optionValue="id"
                          variant="outlined"
                          resettable
                          fullWidth
                          disabled
                        />
                      </ReferenceInput>

                      <TextInput source="refNo" label="REF NO" variant="outlined" fullWidth disabled />
                      <Grid container spacing={2}>
                        <Grid item xs={8} sm={9}>
                          <TextInput source="customerPo" label="Customer PO/RO" fullWidth variant="outlined" disabled />
                        </Grid>
                        <Grid item xs={4} sm={3}>
                          <TextInput source="customerPoLine" label="Line" variant="outlined" fullWidth disabled />
                        </Grid>
                      </Grid>
                      {props?.selectedData?.requestedDeliveryDateDifference !== "" && (
                        <Chip
                          key={9999990}
                          color="primary"
                          variant="outlined"
                          label={props?.selectedData?.requestedDeliveryDateDifference}
                          icon={<InfoOutlined />}
                        />
                      )}
                      <CustomDatetime
                        fullWidth
                        disabled
                        source="requestedDeliveryDate"
                        label="Requested Delivery Date"
                        inputVariant={"dialog"}
                        variant="outlined"
                        showTime
                      />
                      <SelectInput
                        disabled
                        source="requirementCategory"
                        choices={props?.selectedData?.requirementCategoryList ?? []}
                        optionText="category"
                        optionValue="id"
                        fullWidth
                        variant="outlined"
                      />
                      <TextInput
                        source="pbhRequestCustomerRemark.remark"
                        label="Remarks of Customer"
                        multiline
                        fullWidth
                        rows={3}
                        variant="outlined"
                        disabled
                        FormHelperTextProps={{ style: { display: "block", color: "#c80c0f" } }}
                      />

                      {user?.isCustomer !== true && (
                        <TextInput
                          source="poolScopeRejectRemark"
                          label="Pool Scope Reject Remark"
                          variant="outlined"
                          fullWidth
                          disabled
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Separator />

                  <Grid {...gridContainerProps}>
                    <SectionTitle label="Delivery To" />
                  </Grid>
                  <Grid {...gridContainerProps} alignItems={"flex-start"}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        data-testid="text-input-attentionName"
                        source="attentionName"
                        label="Attention Name"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                      <TextInput
                        source="attentionPhone"
                        label="Attention Phone"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                      <TextInput
                        source="shippingAddress"
                        label="Shipping Address"
                        multiline
                        fullWidth
                        rows={3}
                        variant="outlined"
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <TextInput
                        data-testid="text-input-consigneeName"
                        source="consigneeName"
                        label="Company/Consignee Name"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                      <TextInput
                        source="consigneeAddress"
                        label="Company/Consignee Address"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                      <TextInput source="email" label="E-Mail" fullWidth variant="outlined" disabled />
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps} alignItems={"flex-start"}>
                    <Grid item xs={12} sm={12}>
                      <AarStorageSelectForm
                        form={form}
                        eightWingsId={props.eightWingsId}
                        gridContainerProps={gridContainerProps}
                        selectedData={props?.selectedData}
                      />
                    </Grid>
                  </Grid>
                </>
              </Grid>
            </Grid>
          </form>
        )}
      />
      <ExperienceSoftWarningDialog data={props?.selectedData?.experience} type={ExperienceNoteType.Info} />
    </>
  );
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});
// export default EightWingsInfo;
export default connect(mapStateToProps, mapDispatchToProps)(EightWingsInfo);
